export default function () {
    if (localStorage) {
        const data = JSON.parse(localStorage.getItem('compare'));
        if (data && data.isLogged) {
            return true;
        }
        return false;
    }
}
